import { Attr, BelongsTo, Model } from "spraypaint";
import type { JsonapiResourceDoc } from "spraypaint/lib-esm/jsonapi-spec";

import { $streemApiV1 } from "shared/boot/api";
import { ApplicationRecord } from "shared/services/spraypaint";
import type { OutreachSavedSearchState } from "shared/stores/outreachContacts";

import type Organisation from "./Organisation";
import type User from "./User";

@Model()
class OutreachSavedSearch extends ApplicationRecord {
  static jsonapiType = "outreach_saved_searches";

  @Attr({ persist: false }) archivedAt?: string;

  @Attr({ persist: false }) createdAt?: string;

  @Attr({ persist: false }) lastOpenedAt?: string;

  @Attr() name: string;

  @BelongsTo() organisation: Organisation;

  @Attr({ persist: false }) organisationId: number;

  @Attr() organisationTeamId?: number;

  @Attr() state: OutreachSavedSearchState;

  @Attr({ persist: false }) updatedAt?: string;

  @BelongsTo() updatedByUser: User;

  @Attr({ persist: false }) updatedByUserId: number;

  @BelongsTo() user: User;

  @Attr({ persist: false }) userId: number;

  async markOpened(organisationTeamId?: number): Promise<JsonapiResourceDoc> {
    const endpoint = `outreach_saved_searches/${this.id}/last_opened_at`;

    const response = organisationTeamId
      ? await $streemApiV1.put<JsonapiResourceDoc>(endpoint, {
          params: { organisation_team_id: organisationTeamId },
        })
      : await $streemApiV1.put<JsonapiResourceDoc>(endpoint);

    return response.data;
  }
}

export default OutreachSavedSearch;
